<template>
  <div>
    <van-form @submit="onSubmit">
      <van-cell-group inset>
        <van-cell @click="showStockSelect">
          <van-field
            autocomplete="off"
            v-model="formData.scName"
            inputmode="none"
            name="scName"
            label="仓库"
        /></van-cell>
        <van-cell>
          <van-field
            autocomplete="off"
            label="商品编号"
            v-model:value="formData.productCode"
            allow-clear
          />
        </van-cell>
        <van-cell>
          <van-field
            autocomplete="off"
            label="商品名称"
            v-model:value="formData.productName"
            allow-clear
          />
        </van-cell>
        <van-cell @click="showDialog">
          <van-field
            autocomplete="off"
            v-model="formData.categoryName"
            inputmode="none"
            name="categoryName"
            label="所属类目名"
          >
          </van-field>
        </van-cell>
        <van-cell @click="showBizTypeDialog">
          <van-field
            autocomplete="off"
            v-model="formData.bizTypeName"
            inputmode="none"
            name="bizTypeName"
            label="业务类型"
          >
          </van-field>
        </van-cell>
          
        <!-- <van-cell @click="showBrandDialog">
          <van-field
            autocomplete="off"
            label="商品品牌"
            name="brandId"
            v-model:value="formData.brandName"
          ></van-field>
        </van-cell> -->
        <!-- <van-cell>
              <van-field
           autocomplete="off"
                v-model="formData.supplierId"
                name="supplierId"
                label="会员名称"
              >
              </van-field>
            </van-cell> -->
        <!-- <van-cell>
              <van-field
           autocomplete="off"
                v-model="formData.createBy"
                name="createBy"
                label="操作人"
              >
              </van-field>
            </van-cell> -->
        <van-cell>
          <van-field
            autocomplete="off"
            v-model="formData.createStartTime"
            name="createStartTime"
            label="操作日期"
            inputmode="none"
            readonly
            @click="openDatePicker('createStartTime')"
          >
          </van-field>
          <van-field
            autocomplete="off"
            v-model="formData.createEndTime"
            name="createEndTime"
            label="至"
            readonly
            @click="openDatePicker('createEndTime')"
          >
          </van-field>
        </van-cell>
        <!-- <van-cell>
              <van-field
           autocomplete="off"
                v-model="formData.approveBy"
                name="approveBy"
                label="审核人"
              >
              </van-field>
            </van-cell> -->
        <!-- <van-cell>
              <van-field
           autocomplete="off"
                v-model="formData.approveStartTime"
                name="approveStartTime"
                label="审核日期"
                readonly
                @click="openDatePicker('approveStartTime')"
              >
              </van-field>
              <van-field
           autocomplete="off"
                v-model="formData.approveEndTime"
                name="approveEndTime"
                label="至"
                readonly
                @click="openDatePicker('approveEndTime')"
              >
              </van-field>
            </van-cell> -->
        <!-- <van-cell>
              <van-field
           autocomplete="off"
                v-model="formData.purchaser"
                name="purchaser"
                label="采购员"
              >
              </van-field>
            </van-cell> -->
        <van-popup
          close-on-click-overlay
          v-model:show="showStatusPicker"
          round
          position="bottom"
        >
          <van-picker
            show-toolbar
            :columns="statusColumns"
            @cancel="showStatusPicker = false"
            @confirm="onStatusSelectConfirm"
          />
        </van-popup>
        <van-cell>
          <van-button
            round
            block
            type="primary"
            native-type="submit"
            :loading="loading"
            loading-text="查询中..."
          >
            查询
          </van-button>
        </van-cell>
      </van-cell-group>

      <DateTimePicker
        :showPicker="showDatePicker"
        @confirm="onConfirm"
        @cancel="showDatePicker = false"
      ></DateTimePicker>
    </van-form>
    <div style="margin: 6px 0; height: calc(100vh - 336px); overflow: hidden">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="已显示全部"
        ref="scrollContainer"
        @load="getList(true)"
      >
        <div v-for="item in tableData" :key="item.id" class="container">
          <div class="title">
            商品名称:{{ item.productName }}
            <span>(编码：{{ item.productCode }})</span>
          </div>
          <div class="content">
            <div class="left">
              <div class="item flex" v-for="el in columns" :key="el.key">
                <div class="label">{{ el.title }}</div>
                <div class="value">{{ item[el.key] }}</div>
              </div>
            </div>
            <div class="">
              <div
                :style="{ background: getColorByValue(item.bizType) }"
                class="status"
              >
                {{ getText(item.bizType) }}
              </div>
            </div>
          </div>
        </div>
      </van-list>
    </div>
    <StockSelect
      :visible="stockSelectVisible"
      @confirm="stockSelectConfirm"
    ></StockSelect>
    <CategorySelect
      :visible="categorySelectVisible"
      @confirm="categorySelectConfirm"
    ></CategorySelect>
    <BizTypeSelect
      :visible="bizTypeSelectVisible"
      @confirm="bizTypeSelectConfirm"
    ></BizTypeSelect>
  </div>
</template>
<script>
import moment from "moment";
import { query } from "../../../service/api/stock/log";
import CustomTable from "../../../components/customTable.vue";
import {
  PRODUCT_STOCK_BIZ_TYPE,
  getTextByValue,
} from "../../../utils/constants";
import DateTimePicker from "../../../components/dateTimePicker";
import { oneMonthAgoMidnight } from "../../../utils";
import StockSelect from "../../../components/stockSelect.vue";
import CategorySelect from "../../../components/categorySelect.vue";
import BizTypeSelect from "../../../components/bizTypeSelect.vue";

export default {
  name: "index",
  components: {
    CustomTable,
    StockSelect,
    DateTimePicker,
    CategorySelect,
    BizTypeSelect,
  },
  data() {
    return {
      PRODUCT_STOCK_BIZ_TYPE_COLORS: [
        { value: 1, color: "#1890ff" }, // 采购入库 - Antd 蓝色
        { value: 2, color: "#ff4d4f" }, // 采购退货出库 - 红色
        { value: 3, color: "#722ed1" }, // 销售出库 - 紫色
        { value: 4, color: "#13c2c2" }, // 销售退货入库 - 青蓝
        { value: 5, color: "#fa8c16" }, // 零售出库 - 橙黄
        { value: 6, color: "#52c41a" }, // 零售退货入库 - 绿色
        { value: 7, color: "#eb2f96" }, // 盘点入库 - 玫红
        { value: 8, color: "#2f54eb" }, // 盘点出库 - 深蓝
        { value: 9, color: "#fadb14" }, // 库存成本调整 - 明黄
        { value: 10, color: "#a0d911" }, // 库存调整 - 浅绿
        { value: 11, color: "#fa541c" }, // 仓库调拨 - 火山红
        { value: 12, color: "#389e0d" }, // 库存初始化 - 深绿
        { value: 13, color: "#ff9900" }, // 积分兑换出库 - 橙黄
        { value: 14, color: "#fa8c16" }, // 新零售出库 - 橙黄
        { value: 15, color: "#52c41a" }, // 新零售退货入库 - 绿色
      ],
      formData: {},
      brandSelectVisible: false,
      categorySelectVisible: false,
      stockSelectVisible: false,
      bizTypeSelectVisible: false,
      loading: false,
      finished: false,
      showStatusPicker: false,
      action: [
        { name: "审核通过", click: "" },
        { name: "审核拒绝", click: "" },
      ],
      showActions: false,
      columns: [
        { field: "scCode", key: "scCode", title: "仓库编号", width: 100 },
        { field: "scName", key: "scName", title: "仓库名称", width: 100 },
        { field: "lotCode", key: "lotCode", title: "批次号", width: 180 },
        // {
        //   field: "productCode",
        //   key: "productCode",
        //   title: "商品编号",
        //   width: 100,
        // },
        // {
        //   field: "productName",
        //   key: "productName",
        //   title: "商品名称",
        //   width: 100,
        // },
        {
          field: "categoryName",
          key: "categoryName",
          title: "商品类目",
          width: 100,
        },
        { field: "brandName", key: "brandName", title: "商品品牌", width: 100 },
        {
          field: "oriStockNum",
          key: "oriStockNum",
          title: "变动前库存数量",
          width: 100,
        },
        {
          field: "curStockNum",
          key: "curStockNum",
          title: "变动后库存数量",
          width: 100,
        },
        {
          field: "stockNum",
          key: "stockNum",
          title: "变动库存数量",
          align: "right",
          width: 100,
          sortable: true,
        },
        {
          field: "oriTaxPrice",
          title: "变动前含税成本价",
          align: "right",
          width: 100,
          sortable: true,
        },
        {
          field: "curTaxPrice",
          title: "变动后含税成本价",
          align: "right",
          width: 100,
          sortable: true,
        },
        {
          field: "taxAmount",
          key: "taxAmount",
          title: "变动含税金额",
          align: "right",
          width: 100,
          sortable: true,
        },
        {
          field: "createTime",
          key: "createTime",
          title: "操作时间",
          minWidth: 170,
          sortable: true,
        },
        { field: "createBy", key: "createBy", title: "操作人", minWidth: 100 },
        {
          field: "bizCode",
          key: "bizCode",
          title: "单据号",
          width: 180,
          slots: { default: "bizCode_default" },
          sortable: true,
        },
      ],
      tableData: [],
      currentDate: "",
      totalCount: 0,
      pageIndex: 1,
      pageSize: 20,
      totalPage: 1,
      formData: {},
      key: "",
      showDatePicker: false,
    };
  },
  computed: {
    statusColumns() {
      return PRODUCT_STOCK_BIZ_TYPE;
    },
  },
  created() {
    this.formData.createStartTime = oneMonthAgoMidnight();
    this.formData.createEndTime = moment()
      .endOf("day")
      .format("YYYY-MM-DD HH:mm:ss");
    this.onSubmit();
  },
  methods: {
    getColorByValue(value) {
      const item = this.PRODUCT_STOCK_BIZ_TYPE_COLORS.find(
        (item) => item.value == value
      );
      return item ? item.color : "#d9d9d9"; // 默认返回灰色
    },
    getText(status) {
      return getTextByValue(PRODUCT_STOCK_BIZ_TYPE, status);
    },
    categorySelectConfirm(row) {
      if (!Object.keys(row).length) {
        this.categorySelectVisible = false;
        return;
      }
      this.categorySelectVisible = false;
      this.formData.categoryName = row.name;
      this.formData.categoryId = row.id;
    },
    brandSelectConfirm(row) {
      if (!Object.keys(row).length) {
        this.brandSelectVisible = false;
        return;
      }
      this.brandSelectVisible = false;
      this.formData.brandName = row.name;
      this.formData.brandId = row.id;
    },
    showBrandDialog() {
      this.brandSelectVisible = true;
    },
    showDialog() {
      this.categorySelectVisible = true;
    },
    stockSelectConfirm(row) {
      if (Object.keys(row).length === 0) {
        this.stockSelectVisible = false;
        return;
      }
      this.stockSelectVisible = false;
      this.formData.scName = row.name;
      this.formData.scId = row.id;
    },
    showStockSelect() {
      this.stockSelectVisible = true;
    },
    showBizTypeDialog() {
      this.bizTypeSelectVisible = true;
    },
    bizTypeSelectConfirm(row) {
      if (Object.keys(row).length === 0) {
        this.bizTypeSelectVisible = false;
        return;
      }
      this.bizTypeSelectVisible = false;
      this.formData.bizTypeName = row.text;
      this.formData.bizType = row.value;
    },
    onSubmit() {
      this.pageIndex = 1;
      this.getList();
    },
    onStatusSelectConfirm(val) {
      this.formData.status = val.value;
      this.formData.statusText = val.text;
      this.showStatusPicker = false;
    },
    showSettingPopup(e) {
      e.stopPropagation();
      this.showActions = true;
    },
    rowClick({ row, rowIndex, e }) {
      // //进入详情页
      // this.$router.push({
      //   path: "/retail/outDetail/" + row.id,
      // });
    },
    pageChange(pageOptions) {
      this.pageIndex = pageOptions.pageIndex;
      this.pageSize = pageOptions.pageSize;

      this.getList();
    },
    formatter(type, val) {
      if (type === "year") {
        return `${val}年`;
      } else if (type === "month") {
        return `${val}月`;
      }
      return val;
    },
    openDatePicker(key) {
      this.showDatePicker = true;
      this.key = key;
    },
    onConfirm(value) {
      this.formData[this.key] = value;
      this.showDatePicker = false;
    },
    getList(load) {
      if (load) {
        this.pageIndex++;
      }
      this.loading = false;
      this.finished = false;
      this.loading = true;
      const params = {
        ...this.formData,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
      };
      query(params)
        .then((res) => {
          this.loading = false;
          if (load) {
            this.tableData = this.tableData.concat(res.data.datas);
          } else {
            this.tableData = res.data.datas;
          }
          this.totalCount = res.data.totalCount;
          this.totalPage = res.data.totalPage;
          if (this.pageIndex >= this.totalPage) {
            this.finished = true;
          }
          console.log(
            this.pageIndex,
            this.totalPage,
            this.finished,
            this.loading
          );
        })
        .catch(() => {
          this.finished = true;
          this.loading = false;
          console.log("catch", this.finished, this.loading);
        });
      //
      // let params = {};
      // for (const key in this.formData) {
      //   if (Object.prototype.hasOwnProperty.call(this.formData, key)) {
      //     const value = this.formData[key] === "是" ? true : false;
      //     params[key] = value;
      //   }
      // }
      // update(params).then((res) => {
      //
      // });
    },
  },
};
</script>
<style lang="less" scoped>
* {
  touch-action: pan-y;
}
.van-cell {
  padding: 5px 2px 2px 8px !important;
}
::v-deep .color1 {
  color: #333;
}
::v-deep .color2 {
  color: #ee0a24;
}
::v-deep .color3 {
  color: #07c160;
}

.container {
  margin-top: 5px;
  padding: 10px 0 10px 10px;
  background-color: #fff;
  .title {
    font-size: 15px;
    font-weight: 500;
    span {
      color: #777;
    }
  }
  .content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 10px;
    font-size: 14px;
    .left {
      flex: 5;
      .item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 10px;
        .label {
          font-size: 14px;
          color: #333;
        }
        .value {
          font-size: 14px;
          color: #999;
        }
      }
    }
    .status {
      width: 90px;
      height: 26px;
      line-height: 26px;
      text-align: center;
      flex: 2;
      margin-left: 20px;
      border-radius: 13px 0 0 13px;
      color: #fff;
      overflow: hidden;
      font-size: 14px;
    }
    .color1 {
      background: linear-gradient(83deg, #333, #858585);
    }
    .color2 {
      background: linear-gradient(83deg, red, #bfa98c);
    }
    .color3 {
      background: linear-gradient(83deg, #4c9673, #98bf8c);
    }
  }
}
::v-deep .van-list {
  height: 100%;
  overflow: auto;
}
</style>
